<!--商品详情-->
<template>
    <div class="box">
        <!-- <div class="goods-header">
           <div class="header-left" @click="goBusiness">
                <img :src="detail.business_pic_url" alt="">
                <div class="haeder-user-text">{{detail.business_name}}</div>
            </div>
            <div class="header-left" @click="goHome" v-else>
                <img :src="header.logo" alt="">
                <div class="haeder-user-text">{{header.name}}</div>
            </div>
            <div class="header-right flex-end" >
                <span @click="goOrderList">我的订单</span>
            </div>
        </div>-->

        <div class="goods-banner">
            <van-swipe indicator-color="white" :duration="time">
                <van-swipe-item v-if="detail.videos_url" @click="toGoodsVideo">
                    <img :src="detail.videos_url" alt="" v-lazy="detail.videos_url">
                    <img src="../../../assets/images/icon-video-play.png" class="video-img" alt="">
                </van-swipe-item>
                <van-swipe-item v-for="item in detail.pics_url" :key="item.id">
                    <img :src="item" alt="">
                </van-swipe-item>

            </van-swipe>
            <!--			<img src="../../../assets/newImg/pic-goods-detail-banner.png" alt="">-->
        </div>
        <div class="goods-name">{{detail.title}}</div>
        <div class="goods-detail">
            <div class="goods-pri">
                <div class="goods-price">
                    ¥<span>{{detail.price_range[0]|price}}</span>
                </div>
                <div class="goods-price-thr gray-light">
                    ¥{{detail.orig_price|price}}
                </div>
                <div class='good-pri-earn' v-if="detail.max_seller_reward>0" @click="onRule">
                    <div>分享可赚￥{{detail.max_seller_reward/100</div>
                    <img src="https://static.dierqudao.com/images/icon-questionred.png" alt="">
                </div>
            </div>
            <div class="row-yf gray">
                <div class="row-left">已售 {{detail.sold_count + detail.sold_show_count}}</div>
                <!--<div class="row-right-yf">运费 ¥
                    <span v-if="detail.express_price[0] == detail.express_price[1]">{{detail.express_price[0]}}</span>
                    <span v-else>{{detail.express_price[0] +'-'+ detail.express_price[1]}}</span>
                </div>-->
            </div>

            <!--<div class="flex-between share">
                <div class="row-xg gray">
                    <img src="../../../assets/newImg/icon-go.png" alt="">每人限购2件
                </div>
            </div>-->

            <div class="share-box share-right">
                <div class="share-right-text" v-if="detail.max_seller_reward>0" @click="getShare">分享好友可赚 <div>￥{{detail.max_seller_reward/ 100}}</div></div>
                <div class="share-right-texts" v-else @click="getShare">分享给好友</div>
            </div>
        </div>

        <!--<div class="row-tips" v-if="detail.discount_tags.length > 0">
            <GoodsDetailTips :discount="detail.discount_tags"></GoodsDetailTips>
        </div>-->
        <!--<div class="shop-box" v-for="item in detail.shop_list" @click="goShopDetail(item.id)">
            <div class="shop-left">
                <img :src="item.pic_url" alt="">
                <div class="shop-text">
                    <div class="shop-name">{{item.name}}</div>
                    <div class="shop-det gray">{{item.address}}</div>
                </div>
            </div>
            <div class="shop-right flex-end">
                <div>去逛逛</div>
                <img class="row-right" src="../../../assets/images/icon-right.png" alt="">
            </div>
        </div>-->
        <div class='row-list app-border-top'>
            <div class='app-border-bottom flex-between row-one' v-for="(item,index) in detail.extra_data">
                <span>{{item.name}}</span>
                <span>{{item.value}}</span>
            </div>
        </div>

        <div class="detail-title">
            <div></div>
            <span>商品详情</span>
            <div></div>
        </div>
        <!--		<div class="detail-img" ><img src="../../../assets/newImg/WechatIMG941.png" alt=""></div>-->
        <div class="detail-img" v-html="detail.content"></div>
        <CopyRight></CopyRight>

        <van-goods-action class="goods-footer">
           <!-- <van-goods-action-icon class="footer-kf" @click="goHome" icon="home-o">
                <p>首页</p>
            </van-goods-action-icon>
            <van-goods-action-icon class="footer-kf" icon="chat-o" @click="onChat">
                <p>客服</p>
            </van-goods-action-icon>-->
            <van-goods-action-button primary text="立即购买" type="danger" @click="toBuy"/>

        </van-goods-action>

        <!-- 基础用法 -->
        <div class="sku-container">
            <van-sku
                    v-model="showSkuPicker"
                    :sku="skuData.sku"
                    :goods="skuData.goods"
                    :goods-id="skuData.goods_id"
                    :quota="skuData.quota"
                    :quota-used="skuData.quotaUsed"
                    :custom-stepper-config="customStepperConfig"
                    :hide-stock="skuData.hide_stock"
                    :close-on-click-overlay="closeOnClickOverlay"
                    :message-config="messageConfig"
                    @add-cart="onAddCartClicked"
                    @buy-clicked="onBuyClicked"
            >
                <template slot="sku-actions" slot-scope="props">
                    <div class="van-sku-actions">
                        <van-button
                                square
                                size="large"
                                type="warning"
                        >
                            积分兑换
                        </van-button>
                        <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
                        <van-button
                                square
                                size="large"
                                type="warning"
                                @click="props.skuEventBus.$emit('sku:buy');"
                        >
                            立即购买
                        </van-button>
                    </div>
                </template>
            </van-sku>
            <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
            <ShareDialog :show="shareShow" :reward="detail.max_seller_reward" :goods_id="detail.id" :share="share" @shareCancel="shareCancel" />
            <!--<ActivityDialog :row="detail.activity"></ActivityDialog>-->
            <BookDialog :show="bookDialogShow"
                        :wxNote="chat.note"
                        :wxCode="chat.wxcode"
                        :wxPic="chat.pic_url"
                        :phone="chat.phone"
                        @onBookCancle="onBookCancle"></BookDialog>
            <!--<div class="shareShow" v-if="showShare" @click="cancleShare">
                <div>
                    <h2>点击分享给好友</h2>
                </div>
            </div>-->
        </div>
        <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
            <div>
                <h2>点击分享给好友</h2>
            </div>
        </div>
    </div>

</template>
<style scoped>
    .box {
        margin-bottom: 50px;
    }

    .van-swipe .video-img {
        position: absolute;
        left: 3.25rem;
        top: 2.1rem;
        z-index: 20px;
        width: 50px;
        height: 50px;
    }

    .copybox {
        padding: 0.2rem 0 0.6rem;
    }
    .share {
        padding-bottom: 0.2rem;
    }

    .shareShow {
        position: fixed;
        text-align: center;
        width: 100%;
        height: 100%;
        z-index: 10000;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.68);
        color: rgb(255, 255, 255);
    }

    .shareShow div {
        background: url(https://static.dierqudao.com/images/cheesemanv2.0/icon_share_arrow.png) no-repeat right top;
        height: 100%;
        background-size: 100px;
        padding: 180px 0 0 0;
        margin: 10px;
        line-height: 40px
    }

    .shareShow h2 {
        /*font-size: 1.8rem*/
        font-size: 0.8rem
    }
    .share-box {
        position: fixed;
        right: 20px;
        /*top: 60%;*/
        top: 53%;
        z-index: 2;
    }
    .share-right {
        margin-right: -50px;
        width:153px;
        height:49px;
        line-height: 49px;
        background:linear-gradient(180deg,rgba(255,101,131,1) 0%,rgba(253,53,76,1) 100%);
        box-shadow:0px 2px 6px 0px rgba(255,66,90,1);
        border-radius:46px;
        text-align: center;
    }

    .share-right-text {
        width:124px;
        height:44px;
        font-size:14px;
        padding-top: 4px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height: 22px;
    }

    .share-right-texts {
        width:124px;
        height:44px;
        font-size:14px;
        padding-top: 4px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height: 40px;
    }
    .van-goods-action-icon__icon {
        color: #7d7e80;
        font-size: 20px;
    }

    .van-sku-actions button:first-child {
        display: none !important;
    }

    /*.van-sku-actions .van-button--danger {*/
    /*	background: #ff976a!important;*/
    /*}*/
    .flex-end {
        justify-content: flex-end;
    }
    .haeder-user-text{
        width: 80px;
        text-align: center;
    }

    .goods-header {
        height: 45px;
        /*line-height: 45px;*/
        background: #E43131;
        color: #fff;
        padding-right: 0.2rem;

        display: flex;
        justify-content: space-between;
    }

    .header-left {
        width: 2.5rem;
        background: #AE1F1F;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        font-size: 12px;
        padding-left: 0.2rem;

        float: left;

    }

    .header-left img {
        width: 30px;
        height: 30px;
        border-radius: 5px;
        margin-right: 0.1rem;
    }

    .goods-banner img {
        width: 100%;
        height: 100%;
    }

    .goods-name {
        font-size: 15px;
        padding: 0.15rem 0.13rem;
    }

    .goods-detail {
        padding: 0 0.3rem;
    }

    .goods-pri {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .good-pri-earn{
        width:auto;
        padding: 2px 2px ;
        background:rgba(253,232,234,1);
        border-radius: 2px;
        /* border:2rpx solid rgba(253,40,64,1); */
        font-size: 12px;
        color: #FD2840;
        text-align: center;
        margin-left: 7.5px;
        display: flex;
    }

    .good-pri-earn img {
        width: 12px;
        height: 12px;
        padding: 2px 4px;
    }

    .goods-price {
        font-size: 12px;
        color: #FD2840;
    }

    .goods-price span {
        font-size: 16px;
        font-weight: 500;
    }

    .goods-price-thr {
        font-size: 12px;
        text-decoration: line-through;
        margin: 3px 0 0 0.3rem;
    }

    .row-yf {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        padding: 0.2rem 0;
        border-bottom: 1px solid #EFEFEF;
    }

    .row-xg {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 12px;
        padding: 0.2rem 0;
        /*border-bottom: 1px solid #EFEFEF;*/
    }

    .row-xg img {
        margin-right: 0.15rem;
    }

    .row-right {
        width: 16px;
        height: 16px;
        margin-right: 0.1rem;
    }

    .row-tips {
        padding: 0 15px 10px;
        border-bottom: 1px solid #EFEFEF;
    }
   /* .row-tips {
        padding: 0.2rem 0;
        border-bottom: 1px solid #EFEFEF;
    }*/

    .shop-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.21rem;
    }

    .shop-left img {
        width: 0.88rem;
        height: 0.88rem;
        border-radius: 100%;
        margin-right: 0.2rem;
    }

    .shop-left,
    .shop-right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .shop-right img {
        width: 16px;
        height: 16px;
    }

    .shop-name {
        font-size: 13px;
    }

    .shop-right {
        font-size: 12px;
        margin-right: 0.2rem;
    }

    .shop-det {
        font-size: 11px;
    }

    .shop-text {
        height: 100%;
        width: 220px;
    }

    .row-list {
        color: #181818;
        font-size: 12px;
        padding: 0 15.5px;
    }

    .row-one {
        padding: 15.5px 0;
    }

    .app-border-top {
        border-top: 0.1rem solid #EFEFEF;
    }

    .app-border-bottom {
        border-bottom: 1px solid #efefef;
    }


    .row-group {
        border-top: 0.1rem solid #EFEFEF;
    }

    /* .row-group::after{
        border: none;
    } */
    .row-group .van-cell {
        width: auto;
        color: #181818;
        font-size: 12px;
        padding: 0.2rem 0;
        margin: 0 0.31rem;
        border-bottom: 1px solid #EFEFEF;
    }

    .remark-box {
        padding: 0 0.3rem;
    }

    .remark-header {
        padding: 0.3rem 0;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .remark-good {
        font-size: 12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .remark-good span {
        color: #FD2840;
        margin-left: 0.1rem;
    }

    .remark-li img {
        width: 7.09rem;
        height: 3.93rem;
    }

    .detail-title {
        width: 7.5rem;
        line-height: 0.5rem;
        height: 0.5rem;
        background: rgba(239, 239, 239, 1);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .detail-title div {
        width: 0.62rem;
        height: 1px;
        background: rgba(0, 0, 0, 1);
        opacity: 0.08;
    }

    .detail-title span {
        margin: 0 0.2rem;
    }

    .detail-img >>> img {
        width: 100%;
    }

    .detail-img {
        margin-bottom: 50px;
    }

    .detail-img >>> video {
        width: 100%;
    }

    .like-goods {
        padding: 0 0.23rem;
        background: rgba(239, 239, 239, 1);
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-bottom: 50px;
    }

    .like-one {
        background: #fff;
        width: 3.45rem;
        margin-bottom: 0.2rem;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .like-one:nth-child(2n) {
        margin-left: 0.13rem;
    }

    .like-goods-img {
        width: 3.45rem;
        height: 3.45rem;

    }

    .like-one-name {
        color: #333333;
        height: 0.8rem;
        line-height: 0.4rem;
        font-weight: 500;
        padding: 0 0.2rem;
    }

    .like-one-pri {
        margin: 0.2rem;
    }

    .like-one-pri span {
        padding: 2px 3px;
        background: #FD2840;
        font-size: 9px;
        color: #fff;
        border-radius: 2px;
    }

    .like-one-price {
        padding: 0.2rem;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .like-red-price {
        color: #FD2840;
    }

    .like-big-pri {
        font-size: 17px;
    }

    .like-price-thr {
        text-decoration: line-through;
        margin-left: 0.1rem;
    }

    .footer-kf {
        align-items: center;
    }

    .footer-kf img {
        width: 20px;
        height: 20px;
        margin: -5px 0 5px 0;
    }
</style>

<script>
    import Vue from 'vue'
    import {
        Cell,
        CellGroup,
        GoodsAction,
        GoodsActionIcon,
        GoodsActionButton,
        Toast
    } from 'vant';
    import ShareDialog from '@/components/ShareDialog.vue';

    Vue.use(Cell).use(CellGroup).use(GoodsAction).use(GoodsActionIcon).use(GoodsActionButton).use(Toast);
    import GoodsDetailTips from '@/components/GoodsDetailTips.vue';
    import LoginDialog from '@/components/LoginDialog.vue';
    import ActivityDialog from '@/components/ActivityDialog.vue';
    import BookDialog from '@/components/BookDialog.vue';
    import CopyRight from '@/components/CopyRight.vue';

    export default {
        name: 'ShopGoodsDetailSellerShare',
        components: {
            GoodsDetailTips,
            LoginDialog,
            ShareDialog,
            ActivityDialog,
            BookDialog,
            CopyRight
        },
        data: function () {
            return {
                bookDialogShow: false,
                loginShow: false,
                shareShow: false,
                detail: {
                    pics_url: [],
                    price_range: [],
                    express_price: [],
                    activity: {},
                    discount_tags: []

                },
                header: {},
                business: {},
                share: {},
                chat: {},
                time: 300,

                skuData: {
                    sku: {
                        list: [],
                        tree: [],
                        none_sku: false,  // 是否无规格商品
                        hide_stock: false,  // 是否隐藏剩余库存
                    },
                    goods: {},
                    goods_id: 0,
                    quota: 0,
                    quotaUsed: 0,

                },
                customStepperConfig: {
                    quotaText: '',
                },
                showSkuPicker: false,
                showShare: false,
                showWxShare: false,
                closeOnClickOverlay: true,
                messageConfig: {},
                business_id: 0,
            }
        },
        filter: {},
        mounted() {
            document.title = '商品详情';
            let that = this;
            that.getShopGoodsDetail();
            that.business_id = localStorage.getItem('_business_id')

            let href = window.location.href.split('#')
            if(href[1] == 'share') {
                that.showWxShare = true;
            }
        },
        destroyed() {
        },
        methods: {
            getShopGoodsDetail() {
                let id = this.$route.query.id;
                let that = this;
                let total = 0;

                this.$api.get('/api/shopgoods/goodsdetail', {'id': id}, res => {
                    that.detail = res.data.data
                    that.header = res.data.header
                    that.share = res.data.share
                    that.chat = res.data.chat

                    that.skuData.sku = res.data.sku
                    that.skuData.sku.messages = []

                    that.skuData.goods = {
                        title:  that.detail.title,
                        picture: that.detail.pic_url
                    }

                    that.wxShare(res.data.share.title, res.data.share.desc, res.data.share.url, res.data.share.pic_url);

                    // 总数量
                    that.skuData.sku.list.map(sku => {
                        total += sku.stock_num;
                    })

                    that.skuData.sku.stock_num = total
                    that.skuData.sku.price = that.detail.price_range[0] / 100 + '-' + that.detail.price_range[1] / 100
                    that.skuData.goods_id = that.detail.id

                    that.skuData.quota = that.detail.user_buy_limit
                    that.skuData.quotaUsed = that.detail.buy_count
                    if(that.skuData.quota > 0) {
                        that.customStepperConfig.quotaText = '(每人限购' + that.skuData.quota + '件)';
                    }
                    // console.log(res.data.data)
                })
            },

            onRule() {
                this.$router.push({
                    path: '/index/contentdetail',
                    query: {
                        id: 8
                    }
                })
            },
            onShareCancel() {
                this.showWxShare = false;
            },

            goBusiness() {
                this.$router.push({
                    path: '/self/index?business_id=' + this.detail.business_id
                })
            },

            toBuy(){
                this.showSkuPicker = true;
            },

            loginSuccess(res) {
                console.log('-------登录成功--------', res);
                this.loginShow = false;
            },

            loginCancel() {
                console.log('-------取消登录--------');
                this.loginShow = false;
            },

            onChat() {
                if(!this.chat.wxcode) {
                    Toast('商户暂未配置')
                    return;
                }
                this.bookDialogShow = true
            },

            toLoginCheck() {
                let that = this;
                that.$api.get('/api/cart/detail', {}, (res) => {
                    that.shareShow = true;
                },(res) => {
                    if (res.code == 401 || res.code==402) {
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                });
            },

            onBookCancle() {
                this.bookDialogShow =false
            },

            shareCancel() {
                console.log('-------取消分享-------')
                this.shareShow = false;
            },

            getShare() {
                let that = this;
                that.toLoginCheck()
            },

            goShopDetail(id) {
                this.$router.push({
                    path: '/shopdetail',
                    query: {
                        id: id
                    }
                })
            },

            toGoodsVideo() {
                let id = this.$route.query.id;
                this.$router.push({
                    path: '/goodsvideo',
                    query: {
                        id: id
                    }
                })
            },

            // 立即购买
            onBuyClicked(data) {
                let that = this;
                let goods_items = [{
                    goods_id: data.goodsId,
                    sku_id: data.selectedSkuComb.id,
                    count: data.selectedNum,
                }];


                // 存入缓存
                localStorage.setItem("order_check_goods_items", JSON.stringify(goods_items))
                this.$router.push({
                    path: '/shopordercheck'
                })

            },

            // 加入购物车
            onAddCartClicked(data) {
                let that = this;
                let goods_items = {
                    goods_id: data.goodsId,
                    sku_id: data.selectedSkuComb.id,
                    count: data.selectedNum,
                };

                this.$api.post('/api/cart/add', goods_items, res => {
                    console.log(res)
                    if (res.code == 200) {
                        this.$toast('添加成功');
                        that.showSkuPicker = false;
                    }
                })
            },
            goCart() {
                this.$router.push({path: '/self/index?business_id=' + this.detail.business_id + '#cart'})

            },

            goOrderList() {
                this.$router.push({ path:'/orderlist'  })
            },
            goHome() {
                this.$router.push({
                    path: '/self/index',
                    query: {
                        business_id: this.detail.business_id
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// ShopGoodsDetailSellerShare.vue?0dcb66b8